interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white shadow-md' 
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <button 
            onClick={() => scrollToSection('home')}
            className="cursor-pointer"
          >
            <h1 className={`text-2xl font-display font-bold transition-colors ${
              isScrolled ? 'text-navy-900' : 'text-white'
            }`}>
              Iron Asset Management
            </h1>
          </button>

          <div className="flex items-center gap-8">
            <button 
              onClick={() => scrollToSection('home')}
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled 
                  ? 'text-grey-700 hover:text-navy-900' 
                  : 'text-white hover:text-grey-200'
              }`}
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled 
                  ? 'text-grey-700 hover:text-navy-900' 
                  : 'text-white hover:text-grey-200'
              }`}
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled 
                  ? 'text-grey-700 hover:text-navy-900' 
                  : 'text-white hover:text-grey-200'
              }`}
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className={`px-6 py-2.5 rounded-lg font-semibold transition-all cursor-pointer whitespace-nowrap ${
                isScrolled 
                  ? 'bg-navy-700 text-white hover:bg-navy-600' 
                  : 'bg-white text-navy-900 hover:bg-grey-100'
              }`}
            >
              Contact
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
